import { get, post } from '@eika-infrastruktur/request';

import { KREDITTBANKEN_BASE_URL } from '@/react-query/common';

import { EncryptedMessage, KredittbankenViewPinSession } from '@generated-types';

export const getCreditCardViewPinSession = async () =>
    get<KredittbankenViewPinSession>(`${KREDITTBANKEN_BASE_URL}/credit-cards/pin/view-session`);

export const postCreditCardPin = async (message: EncryptedMessage) =>
    post<EncryptedMessage>(`${KREDITTBANKEN_BASE_URL}/credit-cards/pin`, message);
